<template>
    <nav class="nav-center grey lighten-1" role="navigation">
    <div class="nav-wrapper container">
      <ul>
        <li><a class="black-text" href="/">Home</a></li>
        <li><a class="black-text" href="create">Create</a></li>
        <li><a class="black-text" href="list">List</a></li>
        <li><a class="black-text" href="query">Query</a></li>
        <li><a class="black-text" href="logout">Logout</a></li>
      </ul>
    </div>
  </nav>
</template>
  
<script>
import M from 'materialize-css'

export default {
    name: 'App-Navagation',
    components: {
    },
    mounted() {
       M.AutoInit()
    }

}
</script>
<style>
nav ul a,
nav .brand-logo {
  color: #444;
}

nav.nav-center ul {
  text-align: center;
}

nav.nav-center ul li {
  display: inline;
  float: none;
}

nav.nav-center ul li a {
  display: inline-block;
}

.break {
  padding-top: 10%;
  padding-bottom: 10%;
}

.small-break {
  padding-top: 4%;
  padding-bottom: 4%;
}
</style>